export const ACTIONS_VIEW_ALL = 'view all';
export const ACTIONS_EDIT_ALL = 'edit all';
export const ACTIONS_VIEW_COSTS = 'view costs';
export const ACTIONS_VIEW_UPDATES = 'view updates';
export const ACTIONS_VIEW_ACTION_DUE_DATE = 'view due date';
export const ACTIONS_TAG = 'tag actions';
export const ACTIONS_ASSIGN = 'assign';
export const ACTIONS_APPROVE = 'approve';
export const ACTIONS_VIEW_TEAM_ACTIONS = 'view team actions';
export const ACTIONS_BULK_ADD_NOTE = 'bulk add note';
export const ACTIONS_BULK_APPROVE_SUBMITTED = 'bulk approve submitted';
export const ACTIONS_BULK_APPROVE_ADMIN = 'bulk approve admin';
export const ACTIONS_BULK_UNAPPROVE_ADMIN = 'bulk unapprove admin';
export const ACTIONS_BULK_QUERY = 'bulk query';
export const ACTIONS_BULK_REMOVE_TAG = 'bulk remove tag';
export const ACTIONS_QUERY = 'query';
export const ACTIONS_REJECT = 'reject';
export const ACTIONS_SUBMIT_FOR_APPROVAL = 'submit for approval';
export const ACTIONS_RESPOND_TO_QUERY = 'respond to query';
export const ACTIONS_ADD_NOTE = 'add note';
export const ACTIONS_QUERY_ESCALATE_ANY = 'escalate to any query';
export const ACTIONS_QUERY_REPLY_ANY = 'reply to any query';
export const ACTIONS_MANAGE_WORK_PLANS = 'manage work plans';
export const ACTIONS_DOWNLOAD_TO_PDF = 'download to pdf';
export const ACTIONS_NO_ACCESS = 'no access';
export const ACTIONS_EDIT_WORK_ORDERS = 'edit work orders';
export const ACTIONS_EDIT_EXTENDED_DUE_DATE = 'edit extended due date';
export const ACTIONS_VIEW_WORK_ORDERS = 'view work orders';
export const ACTIONS_VIEW_REG7_ACTIONS = 'view reg7 actions';
export const ACTIONS_EXPORT_AUDIT_TRAIL = 'export audit trail';
export const ACTIONS_EDIT_DATE_REFERRED_TO_LEGAL = 'edit date assigned to legal';

// Frontend only
export const ACTIONS_DOWNLOAD_TO_CSV = 'download to csv';
export const ACTIONS_ADD_CLIENT_ACTIONS = 'add client actions';
export const ACTIONS_DOWNLOAD_ALL_ACTIONS = 'download all actions';
export const ACTIONS_VIEW_CLIENT_ACTIONS = 'view client actions';
export const ASSETS_VIEW_ASSETS_INVENTORY = 'view inventory';
export const ASSETS_DOWNLOAD_TO_CSV = 'download inventory';

// admin
export const ADMIN_USER_MANAGEMENT = 'user management';
export const ADMIN_TEAM_MANAGEMENT = 'team management';
export const ADMIN_ORGANISATION_HIERARCHY = 'organisation hierarchy';
export const ADMIN_CHANGE_CLIENT = 'change client';
export const ADMIN_VIEW_OWN_TEAM_USERS = 'view own team users';
export const ADMIN_VIEW_ACTION_STATUS_REPORTS = 'view action status reports';

// properties
export const PROPERTIES_VIEW_PROPERTIES = 'view properties';
export const PROPERTIES_SEARCH_PROPERTIES = 'search properties';
export const PROPERTIES_ADD_PROPERTIES = 'add properties';
export const PROPERTIES_EDIT_PROPERTIES = 'edit properties';
export const PROPERTIES_EDIT_PROPERTY_ACCESS = 'edit property access';
export const PROPERTIES_EDIT_PROPERTY_CONTACTS = 'edit property contacts';
export const PROPERTIES_EDIT_PROPERTY_TENURE = 'edit property tenure';
export const PROPERTIES_UPLOAD_DOCUMENTS = 'upload documents';
export const PROPERTIES_DOWNLOAD_REPORTS = 'download reports';
export const PROPERTIES_REQUEST_NEW_JOB = 'request new job';

// jobs
export const JOBS_VIEW_JOBS = 'view jobs';
export const JOBS_REMOVE_PROPERTIES_FROM_JOB = 'remove properties from job';
export const JOBS_JOB_APPROVAL = 'job approval';
export const JOBS_PROPERTY_QUERIES = 'property queries';
export const JOBS_VIEW_JOB_REQUESTS = 'view job requests';
export const JOBS_MANAGE_JOB_REQUESTS = 'manage job requests';
export const JOBS_VIEW_HAND_INS = 'view job hand-ins';

// files
export const FILES_FILE_SHARING = 'file sharing';

// apps
export const APPLICATIONS_CREATE_APP = 'create application';
export const APPLICATIONS_CREATE_MACHINE_APP = 'create machine application';

export const PERMISSION_TYPE_ACTION = 'actions';
export const PERMISSION_TYPE_ASSETS = 'assets';
export const PERMISSION_TYPE_ADMIN = 'admin';
export const PERMISSION_TYPE_PROPERTIES = 'properties';
export const PERMISSION_TYPE_JOBS = 'jobs';
export const PERMISSION_TYPE_APPS = 'applications';
export const PERMISSION_TYPE_FILES = 'files';
export const PERMISSION_TYPE_BSC = 'building safety case';

// document vault
export const DOCUMENT_VAULT_ACCESS = 'document vault access';

// BSC

export const BSC_VIEW_CASE = 'view building safety case';
export const BSC_VIEW_ACTIONS = 'view bsc actions';

export default {
  ACTIONS_VIEW_ALL,
  ACTIONS_VIEW_COSTS,
  ACTIONS_VIEW_ACTION_DUE_DATE,
  ACTIONS_VIEW_UPDATES,
  ACTIONS_EDIT_ALL,
  ACTIONS_TAG,
  ACTIONS_ASSIGN,
  ACTIONS_APPROVE,
  ACTIONS_VIEW_TEAM_ACTIONS,
  ACTIONS_BULK_ADD_NOTE,
  ACTIONS_BULK_APPROVE_SUBMITTED,
  ACTIONS_BULK_APPROVE_ADMIN,
  ACTIONS_BULK_UNAPPROVE_ADMIN,
  ACTIONS_BULK_QUERY,
  ACTIONS_QUERY,
  ACTIONS_REJECT,
  ACTIONS_SUBMIT_FOR_APPROVAL,
  ACTIONS_RESPOND_TO_QUERY,
  ACTIONS_ADD_NOTE,
  ACTIONS_BULK_REMOVE_TAG,
  ACTIONS_MANAGE_WORK_PLANS,
  ACTIONS_DOWNLOAD_TO_PDF,
  ACTIONS_DOWNLOAD_TO_CSV,
  ACTIONS_ADD_CLIENT_ACTIONS,
  ACTIONS_VIEW_CLIENT_ACTIONS,
  ACTIONS_DOWNLOAD_ALL_ACTIONS,
  ACTIONS_QUERY_ESCALATE_ANY,
  ACTIONS_QUERY_REPLY_ANY,
  ACTIONS_EDIT_WORK_ORDERS,
  ACTIONS_EDIT_EXTENDED_DUE_DATE,
  ACTIONS_VIEW_WORK_ORDERS,
  ACTIONS_NO_ACCESS,
  ADMIN_USER_MANAGEMENT,
  ADMIN_TEAM_MANAGEMENT,
  ADMIN_ORGANISATION_HIERARCHY,
  ADMIN_CHANGE_CLIENT,
  ADMIN_VIEW_OWN_TEAM_USERS,
  ADMIN_VIEW_ACTION_STATUS_REPORTS,
  ASSETS_VIEW_ASSETS_INVENTORY,
  ASSETS_DOWNLOAD_TO_CSV,
  PROPERTIES_VIEW_PROPERTIES,
  PROPERTIES_SEARCH_PROPERTIES,
  PROPERTIES_ADD_PROPERTIES,
  PROPERTIES_EDIT_PROPERTIES,
  PROPERTIES_EDIT_PROPERTY_ACCESS,
  PROPERTIES_EDIT_PROPERTY_CONTACTS,
  PROPERTIES_EDIT_PROPERTY_TENURE,
  PROPERTIES_UPLOAD_DOCUMENTS,
  PROPERTIES_DOWNLOAD_REPORTS,
  PROPERTIES_REQUEST_NEW_JOB,
  JOBS_VIEW_JOBS,
  JOBS_REMOVE_PROPERTIES_FROM_JOB,
  JOBS_JOB_APPROVAL,
  JOBS_PROPERTY_QUERIES,
  JOBS_VIEW_JOB_REQUESTS,
  JOBS_MANAGE_JOB_REQUESTS,
  APPLICATIONS_CREATE_APP,
  APPLICATIONS_CREATE_MACHINE_APP,
  JOBS_VIEW_HAND_INS,
  FILES_FILE_SHARING,
  PERMISSION_TYPE_ACTION,
  PERMISSION_TYPE_ASSETS,
  PERMISSION_TYPE_ADMIN,
  PERMISSION_TYPE_PROPERTIES,
  PERMISSION_TYPE_JOBS,
  PERMISSION_TYPE_APPS,
  PERMISSION_TYPE_FILES,
  DOCUMENT_VAULT_ACCESS,
  ACTIONS_VIEW_REG7_ACTIONS,
  ACTIONS_EXPORT_AUDIT_TRAIL,
  ACTIONS_EDIT_DATE_REFERRED_TO_LEGAL,
};
